import { isDesktopOffline } from '@/api/desktopSync';

export function offlineDocumentRequest(url) {
  const offline = isDesktopOffline();
  if (!offline || !url) return { url, offline: false };
  const parsed = new URL(url, window.location.origin);
  parsed.searchParams.delete('stamp');
  const normalized = url.startsWith('http')
    ? parsed.toString()
    : `${parsed.pathname}${parsed.search}${parsed.hash}`;
  return { url: normalized, offline: true };
}
